module.exports = __webpack_public_path__ + "img/2.06.cd311f82.jpg";